const mResetPassword = {
  mResetPassword: {
    alerts: {
      error: 'Los datos ingresados son incorrectos.'
    },

    buttonPrimary: 'Aceptar',

    formInfo: 'Crear Contraseña',

    inputs: {
      confirm_password: {
        placeholder: 'Confirmar Contraseña'
      },

      password: {
        placeholder: 'Contraseña'
      }
    },

    message: 'Espera un momento...',

    validation: {
      confirm_password: {
        required: 'Confirmar la contraseña es requerido.',
        sameAsPassword: 'Las contraseñas no coinciden.'
      },

      password: {
        minLength: 'La longitud mínima permitida es de 8 caracteres.',
        required: 'Contraseña es requerida.',
        valid: 'La contraseña debe contener minúsculas, mayúsculas y números.'
      }
    }
  }
}

export default mResetPassword
